<div class="popup-header">
    
    <button class="popup-close-button" clickable (click)="closePopup()">
        <!-- <svg xmlns="http://www.w3.org/2000/svg" width="17.657" height="17.657" viewBox="0 0 17.657 17.657">
            <g id="Group_12987" data-name="Group 12987" transform="translate(-5669.475 -484.975)">
                <line id="Line_325" data-name="Line 325" x2="12" y2="12" transform="translate(5672.304 487.804)"
                fill="none" stroke="#bebfbe" stroke-linecap="round" stroke-width="4" />
                <line id="Line_326" data-name="Line 326" x1="12" y2="12" transform="translate(5672.304 487.804)"
                fill="none" stroke="#bebfbe" stroke-linecap="round" stroke-width="4" />
            </g>
        </svg> -->
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 4L4 12" stroke="#004A63" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M4 4L12 12" stroke="#004A63" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>Close</span>
    </button>
    <span *ngIf="title" class="divider">|</span>
    <h2 *ngIf="!commonService.isMobile()" >{{title | translate}}</h2>
    <h2 *ngIf="commonService.isMobile()" >{{title | translate}}</h2>
</div>
<div class="popup-body">
    <ng-template containerRef></ng-template>
</div>

